export enum SnappingLines {
    Top = 'top',
    Left = 'left',
    Right = 'right',
    Bottom = 'bottom',
    HorizontalCenter = 'horizontalCenter',
    VerticalCenter = 'verticalCenter'
}
